export default __webpack_public_path__ + "static/media/reverseCosmos.85cb3f0c.svg";